import React, { useState } from 'react'
import { TableRow, TableCell, IconButton, Chip, Box } from '@mui/material'
import EditIcon from '@mui/icons-material/Edit'
import DeleteIcon from '@mui/icons-material/Delete'
import { useDeleteSalesRecipient } from '../../../api/sales-commission-incentive'
import { getErrorMessage } from '../../../api/utils'
import { useSnackbar } from 'notistack'
import ConfirmDeleteDialog from '../../../component/shared/component/ConfirmDeleteDialog'

const RecipientRow = ({ data, onEdit, refetch }) => {
  const [openDelete, setOpenDelete] = useState(false)
  const { enqueueSnackbar } = useSnackbar()
  const { mutateAsync: deleteRecipient, isLoading: isDeleting } = useDeleteSalesRecipient()

  const handleDelete = async () => {
    try {
      await deleteRecipient(data._id)
      enqueueSnackbar('Recipient deleted', { variant: 'success' })
      refetch()
      setOpenDelete(false)
    } catch (err) {
      enqueueSnackbar(getErrorMessage(err), { variant: 'error' })
    }
  }

  return (
    <>
      <TableRow hover>
        <TableCell>{data.name}</TableCell>
        <TableCell>{data.employeeCode}</TableCell>
        <TableCell>{data.email}</TableCell>
        <TableCell>
          <Box display='flex' flexWrap='wrap' gap={0.5}>
            {data.salesIds?.map((id) => (
              <Chip key={id} label={id} size='small' variant='outlined' color='primary' />
            ))}
          </Box>
        </TableCell>
        <TableCell align='right'>
          <IconButton onClick={onEdit} color='primary' size='small'>
            <EditIcon fontSize='small' />
          </IconButton>
          <IconButton onClick={() => setOpenDelete(true)} color='error' size='small'>
            <DeleteIcon fontSize='small' />
          </IconButton>
        </TableCell>
      </TableRow>
      <ConfirmDeleteDialog
        open={openDelete}
        onClose={() => setOpenDelete(false)}
        onConfirm={handleDelete}
        title='Delete Recipient'
        message={`Are you sure you want to delete ${data.name}?`}
        isLoading={isDeleting}
      />
    </>
  )
}

export default RecipientRow
